module.exports = __webpack_public_path__ + "img/fldc.522e6bad.svg";